import { TwoColumnVideoWidget } from '@orcha/micro-library-widgets-ui';
import { IStylesOverrides } from '@orcha/micro-library-core-ui';
import useTranslation from 'next-translate/useTranslation';

export type TwoColumnVideoProps = {
  bodyHtml?: string;
  styleOverrides?: IStylesOverrides;
  title?: string;
  url?: string;
  primaryButton?: {
    text: string;
    link: string;
    isExternalLink?: boolean;
  };
  secondaryButton?: {
    text: string;
    link: string;
    isExternalLink?: boolean;
  };
  isContentPositionReversed?: boolean;
};
const TwoColumnVideo = (props: TwoColumnVideoProps) => {
  const { t } = useTranslation('microsite');

  return (
    <TwoColumnVideoWidget
      {...props}
      translations={{
        skipVideoContentLink: t('videoWidget.skipVideoContentLink'),
      }}
    />
  );
};

export default TwoColumnVideo;
